import { ReactElement } from 'react';

/**
 * Builds an accessible ARIA label for tooltips.
 * @param title - The title text for the tooltip.
 * @param message - The main message text for the tooltip.
 * @param list - An optional list of additional items to include in the tooltip.
 * @returns A string suitable for use as an ARIA label.
 */
export const buildTooltipAriaLabel = (title?: string, message?: string | ReactElement, list?: Array<string>): string => {
  const messageText = typeof message === 'string' ? message : '';
  return [title, messageText, list?.join(', ')].filter(Boolean).join(' ');
};
